export const agregarTransparencia = (color, alpha) => { 
  return color.replace("rgb", "rgba").replace(")", `, ${alpha})`);
};
